const navigation = {
    locations: [
        { name: "Personal Training Uden", href: route("location-uden") },
        {
            name: "Personal Training Schijndel",
            href: route("location-schijndel"),
        },
    ],
    blogs: [
        { name: "Genetische aanleg", href: route("blogs.twenty-eight") },
        { name: "Zink", href: route("blogs.twenty-nine") },
        { name: "Pre-workout", href: route("blogs.twenty-four") },
        { name: "Fatburners", href: route("blogs.seventeenth") },
    ],
    other: [
        {
            name: 'Boek: "Succesvol afvallen zonder voedinsschema"',
            href: route("success-without-food-schema"),
        },
        {
            name: "Voorwaarden Jumbo spaaractie",
            href: route("points"),
        },
        {
            name: "Algemene voorwaarden",
            href: route("terms"),
        },
    ],
    company: [
        { name: "FAQ", href: route("faq") },
        { name: "Ons programma", href: route("twelve-week-program") },
        { name: "Zakelijk", href: route("business") },
        { name: "Zwangerschap", href: route("pregnancy") },
        { name: "Gamechangers", href: "https://mentalprogram.we-are.club" },
        { name: "Blogs", href: route("blogs.index") },
        { name: "Inloggen", href: "https://mentalprogram.we-are.club/login" },
    ],
    social: [
        {
            name: "Facebook",
            href: "https://www.facebook.com/fitvoorop/",
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: "Instagram",
            href: "https://www.instagram.com/we_are_personal_training/",
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: "LinkedIn",
            href: "https://www.linkedin.com/company/we-are-your-physical-and-mental-personal-training/",
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: "Youtube",
            href: "https://www.youtube.com/channel/UCJ5hSGLclSGtXFGtRSAlbsg/featured",
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
        {
            name: "WhatsApp",
            href: "https://api.whatsapp.com/send?phone=+31636123542",
            icon: (props) => (
                <svg fill="currentColor" viewBox="0 0 24 24" {...props}>
                    <path
                        fillRule="evenodd"
                        d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"
                        clipRule="evenodd"
                    />
                </svg>
            ),
        },
    ],
};

export default () => {
    return (
        <footer className="bg-black" aria-labelledby="footer-heading">
            <h2 id="footer-heading" className="sr-only">
                Footer
            </h2>
            <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                <div className="xl:grid xl:grid-cols-1 xl:gap-8">
                    <div className="grid grid-cols-1 gap-8 xl:col-span-2">
                        {/* <div className="md:grid md:grid-cols-4 md:gap-8"> */}
                        <div className="md:grid md:grid-cols-4 md:gap-8">
                            <div>
                                <h3 className="text-base font-semibold text-we-are-yellow tracking-wider uppercase">
                                    Locaties
                                </h3>
                                <ul role="list" className="mt-4 space-y-4">
                                    {navigation.locations.map((item) => (
                                        <li
                                            key={item.name}
                                            className="ml-0 pl-0"
                                        >
                                            <a
                                                href={item.href}
                                                className="text-base text-gray-400 hover:text-we-are-yellow"
                                            >
                                                {item.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="mt-12 md:mt-0">
                                <h3 className="text-base font-semibold text-we-are-yellow tracking-wider uppercase">
                                    Laatste blogs
                                </h3>
                                <ul role="list" className="mt-4 space-y-4">
                                    {navigation.blogs.map((item) => (
                                        <li
                                            key={item.name}
                                            className="ml-0 pl-0"
                                        >
                                            <a
                                                href={item.href}
                                                className="text-base text-gray-400 hover:text-we-are-yellow"
                                            >
                                                {item.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="mt-12 md:mt-0">
                                <h3 className="text-base font-semibold text-we-are-yellow tracking-wider uppercase">
                                    WE ARE
                                </h3>
                                <ul role="list" className="mt-4 space-y-4">
                                    {navigation.company.map((item) => (
                                        <li
                                            key={item.name}
                                            className="ml-0 pl-0"
                                        >
                                            <a
                                                href={item.href}
                                                className="text-base text-gray-400 hover:text-we-are-yellow"
                                            >
                                                {item.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                            <div className="mt-12 md:mt-0">
                                <h3 className="text-base font-semibold text-we-are-yellow tracking-wider uppercase">
                                    Overig
                                </h3>
                                <ul role="list" className="mt-4 space-y-4">
                                    {navigation.other.map((item) => (
                                        <li
                                            key={item.name}
                                            className="ml-0 pl-0"
                                        >
                                            <a
                                                href={item.href}
                                                className="text-base text-gray-400 hover:text-we-are-yellow"
                                            >
                                                {item.name}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-8 border-t border-gray-200 pt-8 md:flex md:items-center md:justify-between">
                    <div className="flex space-x-6 md:order-2">
                        {navigation.social.map((item) => (
                            <a
                                key={item.name}
                                href={item.href}
                                className="text-gray-400 hover:text-we-are-yellow"
                            >
                                <span className="sr-only">{item.name}</span>
                                <item.icon
                                    className="h-6 w-6"
                                    aria-hidden="true"
                                />
                            </a>
                        ))}
                    </div>
                    <div />
                    <p className="mt-8 text-base text-gray-400 md:mt-0 md:order-1 text-center">
                        &copy; 2022
                        <span className="text-we-are-yellow font-bold">
                            {" "}
                            We
                        </span>
                        <span className="text-we-are-purple font-bold">
                            {" "}
                            Are
                        </span>{" "}
                        Alle rechten voorbehouden.
                    </p>
                    {/* <a
                        href="/algemene-voorwaarden"
                        className="mt-8 block text-base text-gray-400 md:mt-0 md:order-1 hover:text-we-are-yellow"
                    >
                        Algemene voorwaarden
                    </a> */}
                </div>
            </div>
        </footer>
    );
};
